(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pk9-shop-hub"] && !Shopify.designMode) return;
  try {
    (() => {
    const pad = (value) => String(value).padStart(2, '0');
    const countdowns = document.querySelectorAll('[data-pk9-hub-countdown]');
    if (!countdowns.length) return;

    const render = () => {
      let expired = false;

      countdowns.forEach((countdown) => {
        const target = Date.parse(countdown.dataset.target);
        if (Number.isNaN(target)) return;

        const distance = Math.max(0, target - Date.now());
        const totalSeconds = Math.floor(distance / 1000);

        countdown.querySelector('[data-days]').textContent = pad(Math.floor(totalSeconds / 86400));
        countdown.querySelector('[data-hours]').textContent = pad(Math.floor((totalSeconds % 86400) / 3600));
        countdown.querySelector('[data-minutes]').textContent = pad(Math.floor((totalSeconds % 3600) / 60));
        countdown.querySelector('[data-seconds]').textContent = pad(totalSeconds % 60);

        if (distance === 0) expired = true;
      });

      if (expired) {
        window.setTimeout(() => window.location.reload(), 1200);
        return false;
      }

      return true;
    };

    if (!render()) return;
    const interval = window.setInterval(() => {
      if (!render()) window.clearInterval(interval);
    }, 1000);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pk9-universe-gate"] && !Shopify.designMode) return;
  try {
    (() => {
    const pad = (value) => String(value).padStart(2, '0');

    document.querySelectorAll('[data-pk9-countdown]').forEach((countdown) => {
      if (countdown.dataset.initialized === 'true') return;
      countdown.dataset.initialized = 'true';

      const target = Date.parse(countdown.dataset.target);
      if (Number.isNaN(target)) return;

      const days = countdown.querySelector('[data-pk9-days]');
      const hours = countdown.querySelector('[data-pk9-hours]');
      const minutes = countdown.querySelector('[data-pk9-minutes]');
      const seconds = countdown.querySelector('[data-pk9-seconds]');
      const expired = countdown.parentElement.querySelector('[data-pk9-expired]');

      const render = () => {
        const distance = target - Date.now();

        if (distance <= 0) {
          days.textContent = '00';
          hours.textContent = '00';
          minutes.textContent = '00';
          seconds.textContent = '00';

          if (expired) {
            expired.textContent = countdown.dataset.expiredText;
            expired.hidden = false;
          }

          const lastReload = Number(sessionStorage.getItem('pk9_gate_last_reload') || 0);
          if (Date.now() - lastReload > 60000) {
            sessionStorage.setItem('pk9_gate_last_reload', String(Date.now()));
            window.setTimeout(() => window.location.reload(), 1200);
          }
          return false;
        }

        const totalSeconds = Math.floor(distance / 1000);
        days.textContent = pad(Math.floor(totalSeconds / 86400));
        hours.textContent = pad(Math.floor((totalSeconds % 86400) / 3600));
        minutes.textContent = pad(Math.floor((totalSeconds % 3600) / 60));
        seconds.textContent = pad(totalSeconds % 60);
        return true;
      };

      if (!render()) return;
      const interval = window.setInterval(() => {
        if (!render()) window.clearInterval(interval);
      }, 1000);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
